import { env } from '@toggle/helpers/src/utils/env/env';

const rootUrl = env(process.env.NEXT_PUBLIC_ROOT_URL, '864453.co.uk');
export const config = {
  version: process.env.NEXT_VERSION,
  supportEmail: 'support@toggle.ai',
  twitterUsername: 'toggle_ai',
  isLocal: env(process.env.NEXT_PUBLIC_LOCAL),
  urls: {
    root: env(rootUrl, '864453.co.uk'),
    apiRoot: `https://api.${rootUrl}`,
    termsAndCondition: `https://${rootUrl}/resources/terms-and-conditions`,

    cmsApiPath: `https://cms.${rootUrl}`,
    faq: `https://${rootUrl}/resources/earnings-widget-faq`,

    playStore: env(
      process.env.NEXT_PUBLIC_PLAY_STORE_LINK,
      'https://play.google.com/store/apps/details?id=ai.toggle.whatif'
    ),
    appStore: env(
      process.env.NEXT_PUBLIC_APP_STORE_LINK,
      'https://apps.apple.com/gb/app/whatif-earnings/id6444960932'
    ),
    website: `https://${rootUrl}`,
  },
  firebaseConfig: {
    apiKey: env(
      process.env.NEXT_PUBLIC_FB_API_KEY,
      'AIzaSyAg9iL4FUBVzlBFj3u0dKdJOajax1DP2h0'
    ),
    authDomain: env(
      process.env.NEXT_PUBLIC_FB_AUTH_DOMAIN,
      'earnings-web.firebaseapp.com'
    ),
    projectId: env(process.env.NEXT_PUBLIC_FB_PROJECT_ID, 'whatif-app-81b66'),
    storageBucket: env(
      process.env.NEXT_PUBLIC_FB_STORAGE_BUCKET,
      'whatif-app-81b66.appspot.com'
    ),
    messagingSenderId: env(
      process.env.NEXT_PUBLIC_FB_MESSAGING_SENDER_ID,
      '346635316317'
    ),
    appId: env(
      process.env.NEXT_PUBLIC_FB_APP_ID,
      '1:346635316317:web:707e4ed585afa32405b1b4'
    ),
    measurementId: env(
      process.env.NEXT_PUBLIC_FB_MEASUREMENT_ID,
      'G-9RDHRNNCB4'
    ),
  },
};
